//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import  UserInfoToast  from '@/components/toast/userInfo'
    import mixinTxrNewWeb from '@/utils/mixin/mixinTxrNewWeb'
    import mixinVerify from '@/utils/mixin/mixinVerify'
    import { getFormatInfo,getDeScheme } from './index'
    import { store, mutations} from '@/observable/store'
    import { uninsuredInfo } from '@/model/javaApi/present.js'
    import { beautyPage} from '@/model/javaApi/present.js'

    import  InstructionProtocol  from '@/views/stencil/components/instructionProtocol'
    import NewProtocol from '@/views/stencil/components/newProtocol'
    import  Editor  from '@/views/stencil/components/editor'
    import Tab from './components/tab.vue'
    // import Animation from './components/animation.vue'
    import SchemeTab from './components/SchemeTab.vue'
    import Giveup from './components/Giveup'
    import  FixBottom  from './components/fixBottom'
    import Model from './components/model'

import { toApp,appFallback,appCancelFallback } from '@/utils/appBridge'


    export default {
        name: "attachPresentPatch",
        mixins:[mixinTxrNewWeb,mixinVerify],
        data(){
            return {
                allData:{}, // 展示内容 
                gainNames:[], // 滚动信息
                
                currentScheme:{}, //方案信息
                // start:false,
                buyFlag:true, //是否支持领取保险
                current:0, //详情选中
                // key:0,
                fixedBtn:'',
                baseData:{hospitalName:''}, //医美商品数据
                fromPageData:{}, // 核保数据

                schemAlert:false, //方案弹窗
                formAlert:false,// 填单弹窗
                modeShow:false,//服务详情弹框
                protocolInfo:{},
                needschemShow:false
            }
        },
        components:{
            InstructionProtocol,
            NewProtocol,
            Editor,
            Tab,
            UserInfoToast,
            // Animation,
            SchemeTab,
            Giveup,
            FixBottom,
            Model
        },
        computed: {
            // 渠道商品code
            channelCommodityCode(){
                return this.$route.query.channelCommodityCode
            },
            // 主站订单号
            baseNo(){
                return this.$route.query.baseNo ||''
            },
            // 方案code
            scheme_code(){
                return this.$route.query.scheme_code || ''
            },
            // uid
            uid(){
                return store.uid
            },
        },
        created() {
            this.getInfo()
            this.getOrderInfo()
        },
        mounted(){
            window.addEventListener('scroll', ()=>{
                this.fixedBtn = document.getElementById("animationlocation").getBoundingClientRect().top < 0  
            })

            if(this.uid == 0){
                this.needschemShow = false
                this.$refs.userlogin.showoast()
                // console.log(this.$refs)
            }
            this.$nextTick(()=>{
                // 回溯视频
                this.postTX(this.channelCommodityCode)
            })
            
            this.STATISTICS_CONFIG.insur_proinfo_page();

        },
        beforeRouteEnter(to, from, next) {
            // 在当前路由改变，但是该组件被复用时调用
            // 拦截回退
            next(vm=>{
                // 隐私协议弹窗展示时不监听app回退事件
                const plicyKey=localStorage.getItem('insurance-mobile_privacy_plicy_show')
                if(!(plicyKey == null || typeof plicyKey == undefined || plicyKey === 'undefined')){
                    appFallback(() => {
                        vm.$refs.giveup.show()
                    }); 
                }
            })
        },
        beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
            appCancelFallback();
            next()
        },
        deactivated(){
            window.removeEventListener('scroll', this.handleScroll);   //  离开页面清除（移除）滚轮滚动事件
        },
        methods:{
            // 获取数据
            async getInfo(login = ''){
                let data = {'channelCommodityCode':this.channelCommodityCode,ch:this.$route.query.ch || ''}
                // 获取格式化后的赠险信息
                this.allData = await getFormatInfo(data)
                // 刷新组件
                // this.key = this.key+1
                // 获取当前选中的方案
                this.currentScheme = getDeScheme(this.allData.schemes,this.scheme_code)
                this.AppSetTitleBar(this.allData.topTitle,["refresh"]);
                console.log('格式化赠险数据结果：',this.allData)
                if(login&& this.needschemShow){
                    this.schemShow()
                }
                
            },
            submitClick(){
              this.$refs.InstructionProtocol.selectFlag=true
              this.btnClick()
            },
            //立即投保
            btnClick(){ 
                if(this.uid == 0){
                    this.$refs.userlogin.showoast()
                    return false
                }
                if(!this.buyFlag){
                    this.$toast("当前订单状态不支持保险领取"); 
                    return false
                }
                let schemeCurrent = this.currentScheme
                const data = {
                    elements:this.fromPageData,
                    channelCommodityCode:this.channelCommodityCode,
                    isFollow:this.allData.isFollow,
                    originalPrice:schemeCurrent.originalPrice, // 划线价
                    commodityPrice:schemeCurrent.commodityPrice, 
                    price:schemeCurrent.commodityPrice,
                    baseNo:this.$route.query.baseNo || '', // 主站订单号
                    traceId:store.TXoption.bizKey, // 回溯信息
                    schemeCode:schemeCurrent.schemeCode, //方案code  目前只有一种
                    ch:this.$route.query.ch || ''
                }
                console.log('heba',data)
                this.protocolInfo={
                    productName:this.allData.commodityName,
                    buyerName:this.fromPageData['BUYER_NAME'].value,
                    insuredName:this.fromPageData['BUYER_NAME'].value
                }
                // 统一核保
               this.verification(data).then(res=>{
                   this.goConfirm()
                   this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({"ex":{status:'pass' }})
               }).catch(res =>{
                   this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({"ex":{status:'fail' }})
               })
            },
            // 去创建订单
            goConfirm(){
                this.mixinCreatAnOrder(()=>{
                    // 跳转跟单保险操作成功
                    this.$router.push({
                        path: '/detailPaySuccess',
                        query: {
                            channelCommodityCode:this.channelCommodityCode,
                            flag: "postdisable",
                            pid:this.$route.query.pid,
                            ch:this.$route.query.ch
                        },
                    });
                            
                })
            },
            async getOrderInfo(){
                // 获取未投保页信息
                // uninsuredInfo({'channelCommodityCode':this.channelCommodityCode,'baseNo':this.baseNo}).then(res =>{
                //     if(!res){
                //         return false
                //     }
                //     this.gainNames = res.gainNames.map((item,index)=>{
                //         return {desc:item+'刚刚已投保',id:index}
                //     })
                //     if(!res.buyFlag){
                //         this.buyFlag = false
                //         this.$toast("当前订单状态不支持保险领取"); 
                //     }
                // })
                // 
                if(this.baseNo){
                    this.baseData = await beautyPage({baseNo:this.baseNo})
                }
            },
            changeData(from){
                console.log(from)
                this.fromPageData = from.allFromData
            },
            changeScheme(scheme){
                console.log('changeScheme')
                this.currentScheme = scheme
                this.STATISTICS_CONFIG.insur_scheme_schemecard_click({"ex":{scheme:scheme.schemeName }});

            },
            receive(){
                
                if(this.formAlert){
                    this.btnClick()
                }else{
                     // 埋点
                    this.STATISTICS_CONFIG.insur_insurinfoinput_page();
                    this.STATISTICS_CONFIG.insur_scheme_submit_click({"ex":{scheme:this.currentScheme.schemeName }})

                    this.schemAlert = false; 
                    this.formAlert = true;
                }
            },
            go(){
                const pdfURL = 'https://mfinsuranceapi.soyoung.com/base/file/preview/FJ202103090003.pdf'
                const url = `${encodeURIComponent(
                    pdfURL
                )}`;
                this.$router.push({
                    path: "/webpdf",
                    query: {
                        file: url
                    },
                    flag: "postdisable",
                });
            },
            goBack(){
                this.schemShow();
            },
            showDetail(){
                this.STATISTICS_CONFIG.insur_proinfo_insurdetail_click()
                this.modeShow= true
            },
            schemShow(){
                if(this.uid == 0){
                    this.needschemShow = true;
                    this.$refs.userlogin.showoast()
                    return false
                }
                this.schemAlert=true //方案弹窗
                this.formAlert=false// 填单弹窗
                this.STATISTICS_CONFIG.insur_scheme_page({"ex":{scheme:this.currentScheme.schemeName }})
            },
            loginCallback(){
                this.getInfo('login')
            }
        }
    }
